import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import moment from 'moment';
import { Observable } from 'rxjs';
import { Group } from '../../../models/group.model';
import { MomentPipe } from '../../../pipes/moment.pipe';
import { BtnEventStatusComponent } from '../buttons/btn-event-status/btn-event-status.component';
import { ChipColor, ChipComponent } from '../inputs/chip/chip.component';

@Component({
  selector: 'app-calendar',
  standalone: true,
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
  imports: [
    NgIf,
    NgFor,
    RouterLink,
    AsyncPipe,
    BtnEventStatusComponent,
    MomentPipe,
    ChipComponent,
  ],
})
export class CalendarComponent implements OnInit {
  chipColor = ChipColor;
  @Input() events$: Observable<any> = new Observable();
  @Input() group: Group | null | undefined;
  @Input() loading$: Observable<boolean> = new Observable();
  @Input() isAdmin: boolean = false;
  @Output() selectedMonthChange = new EventEmitter<moment.Moment>();
  @Output() duplicateItem = new EventEmitter<any>();

  loadedImages = new Set<string>();

  onImageLoad(id: string) {
    if (this.loadedImages.has(id)) return;
    this.loadedImages.add(id);
    this.loadedImages = new Set(this.loadedImages);
  }

  weekdays = moment.weekdaysShort();

  today: moment.Moment;

  selectedMonth: moment.Moment;
  selectedWeek: number;
  selectedDate: moment.Moment;

  moment = moment;

  firstDayOfMonth = moment().startOf('month');
  daysInMonth = moment().daysInMonth();

  daysByWeeks: any[] = [];

  constructor() {
    this.today = moment().startOf('day');
    this.selectedMonth = moment([this.today.year(), this.today.month()]);
    this.selectedDate = this.today.clone();
    this.selectedWeek = this.selectedDate.diff(this.selectedMonth, 'week');
  }

  ngOnInit(): void {
    this.daysByWeeks = this.parseSelectedMonthByWeeks();
  }

  parseSelectedMonthByWeeks() {
    const daysByWeeks: any[] = [];

    const startOfMonth = moment(this.selectedMonth);
    const endOfMonth = moment(this.selectedMonth).endOf('month');

    let currentDay = startOfMonth.clone();
    let weekIndex = -1;

    while (
      currentDay.isBefore(endOfMonth) ||
      currentDay.isSame(endOfMonth, 'day')
    ) {
      const currentWeek = currentDay.week();
      weekIndex++;
      let index = 0;

      while (
        currentWeek == currentDay.week() &&
        currentDay.isBefore(endOfMonth)
      ) {
        if (daysByWeeks[weekIndex] == null) daysByWeeks[weekIndex] = [];
        daysByWeeks[weekIndex][index] = currentDay.clone();

        currentDay.add(1, 'day');
        if (currentDay == this.selectedDate) this.selectedWeek = weekIndex;
        index++;
      }
    }
    return daysByWeeks;
  }

  dateWithinRange(day: moment.Moment) {
    return (
      day.isSameOrAfter(this.firstDayOfMonth) &&
      day.isSameOrBefore(this.firstDayOfMonth.endOf('month'))
    );
  }

  setSelectedDate(day: moment.Moment, week: number) {
    this.selectedDate = day;
    this.selectedWeek = week;
  }

  setSelectedMonth(month: moment.Moment) {
    this.selectedMonth = month.utc(true);
    this.selectedDate = moment(month).utc(true);
    this.selectedWeek = 0;

    this.daysByWeeks = this.parseSelectedMonthByWeeks();

    // Notifiy parent about month change
    this.selectedMonthChange.emit(this.selectedDate);
  }

  nextMonth() {
    this.setSelectedMonth(
      moment(this.selectedMonth).add(1, 'months').startOf('month')
    );
  }

  previousMonth() {
    this.setSelectedMonth(
      moment(this.selectedMonth).subtract(1, 'months').startOf('month')
    );
  }

  duplicate(item: any) {
    this.duplicateItem.emit(item);
  }
}
